import Vue from 'vue';
import api from '@/api/api';


const GETADDRESSLIST = 'GETADDRESSLIST';
const SETDEFAULTADDRESS = 'SETDEFAULTADDRESS';
const DELADDRESS = 'DELADDRESS';

const CHECKADDRESS = 'CHECKADDRESS';


export default {
	state: {
		addressList: [],//地址列表
		page:0,
		pageSize: 10,
		totalPage: 0,
		checkedOrderAddress:'',//选择的订单页地址
	},
	actions: {
		// getAddressList({ commit ,state}){
		// 	var parma = {
		// 		pageNo: state.page,//		number	
		// 		pageSize: state.pageSize
		// 	}
		// 	api.get('api/appclient/v2/user/address/order/list',{},function(res){
		// 		var res = res.body;
		// 		commit('GETADDRESSLIST',res.data)
		// 	})
		// },
		getAddressListManager({ commit ,state},isOrderAddress){
			var parma = {
				pageNo: state.page+1,//		number	
				pageSize: state.pageSize,
				isOrderAddress:isOrderAddress

			}
			return new Promise(function(resolve,reject){
				api.post('api/appclient/v2/user/address/list',parma,function(res){
					var res = res.body;
					commit('GETADDRESSLIST',res.data);
					resolve();
				})
			})
		},
		setDefaultAddress({ commit },option){
			// api.get('/setDefaultAddress',{id: option.id},function(res){
			api.post('api/appclient/v2/user/address/default/'+option.id,'',function(res){
				var res = res.body;
				commit('SETDEFAULTADDRESS',option)
			})
		},
		delAddress({ commit },option){
			api.post('api/appclient/v2/user/address/del/'+option.id,{id:option.id },function(res){
				var res = res.body;
				commit('DELADDRESS',option)
			})
		},
		getEditAddress({ commit },id){
			return new Promise(function(resolve,reject){
				// api.get('/addressEditGet',{id:id},function(res){
				api.get('api/appclient/v2/user/address/'+id,'',function(res){
					var res = res.body;
					if(res.meta.code == '00000'){
						resolve(res);
					}
				})
			})
			
		},
		addAddressSubmit( { commit } ,parma){
			return new Promise(function(resolve,reject){
				api.post('api/appclient/v2/user/address/add',parma,function(res){
					var res = res.body;
					if(res.meta.code == '00000'){
						resolve();
					}
				})
			})
		},
		editAddressSubmit( {commit},parma ){
			return new Promise(function(resolve,reject){
				api.post('api/appclient/v2/user/address/edit',parma,function(res){
					var res = res.body;
					if(res.meta.code == '00000'){
						resolve();
					}
				})
			})
		},
		checkAddress( { commit,state }, item){
			state.checkedOrderAddress = item;
		},
		initPageNo( { commit,state}){
			state.page = 0;
		}

	},
	mutations: {
		GETADDRESSLIST(state,data){
			state.addressList = data.pageNo==1 ? data.itemList : state.addressList.concat(data.itemList);
			state.page = data.pageNo;
			state.totalPage = data.totalPage;
		},
		SETDEFAULTADDRESS(state, option){
			state.addressList.map((item)=> item.isDefault = 0);
			state.addressList[option.index].isDefault  = 1;
		},
		DELADDRESS(state,option){
			state.addressList.splice(option.index,1);
		}
	}
}


// WEBPACK FOOTER //
// ./src/js/store/addressState.js